<template>
  <div class="modal-overlay" @click.self="this.$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Selecionar Cliente</h5>
        <div role="button" class="btn-close" @click="this.$emit('close')"></div>
      </div>

      <div class="modal-body">
        <form @submit.prevent="searchClients">
          <row-component>
            <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <label>Nome:</label>
              <input-component v-model="formData.name" />
            </col-component>

            <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
              <label>CNPJ:</label>
              <input-component v-model="formData.cnpj" placeholder="00.000.000/0000-00" />
            </col-component>

            <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
              <label>CPF:</label>
              <input-component v-model="formData.cpf" placeholder="000.000.000-00" />
            </col-component>

            <col-component class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-0 mt-lg-4">
              <button-submit class="w-100" type="submit" icon="search" name="Pesquisar" />
            </col-component>
          </row-component>
        </form>

        <div class="mt-3">
          <row-component>
            <col-component
              class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
              v-for="(data, index) in clientList"
              :key="index"
            >
              <div class="d-flex align-items-center bg-body-secondary p-2 position-relative mt-2">
                <div class="h-100">
                  <img class="avatar__image" v-if="data.photo" :src="data.photo" alt="" />
                  <img class="avatar__image" v-else src="@/assets/avatar.png" alt="" />
                </div>
                <div class="ms-3 w-75">
                  <p class="mb-1 text-truncate">{{ data.surname || data.name }}</p>
                  <p class="mb-0">
                    {{ data.cnpj }}
                    {{ data.cpf }}
                  </p>
                </div>
                <div class="position-absolute end-0 me-1 me-lg-3">
                  <button-submit icon="plus" @click="selectClient(data)" />
                </div>
              </div>
            </col-component>
          </row-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartClientSearch',

  components: {
    RowComponent,
    ColComponent,
    InputComponent,
    ButtonSubmit
  },

  created() {
    this.searchClients();
  },

  data() {
    return {
      formData: {
        name: '',
        cnpj: '',
        cpf: '',
        status: 1
      },
      clientList: []
    };
  },

  methods: {
    searchClients() {
      this.$store
        .dispatch('loadCustomers', this.formData)
        .then(response => {
          this.clientList = response.data || [];
        })
        .catch(() => {
          toast.error('Erro ao carregar clientes', { timeout: 1500 });
        });
    },

    selectClient(client) {
      this.$emit('select', client);
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 1200px;
  max-width: 90%;
  position: relative;
  max-height: 80%;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.avatar__image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
